import { configureStore, type Selector as GenericStateSelector, type Store } from '@reduxjs/toolkit';
import {
  type TypedUseSelectorHook,
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
} from 'react-redux';

import epics from 'Core/epics/index';
import createEpicsMiddleware from 'Core/middlewares/epics';

import reducer from './reducers/index';

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(createEpicsMiddleware(epics)),
  devTools: CONVERMAX_IS_LOCAL_ENV,
});

export default store;

export type ReduxStateType = ReturnType<typeof reducer>;

export type ReduxStoreType = Store<ReduxStateType>;

export type AppDispatch = typeof store.dispatch;

export type Selector<R> = GenericStateSelector<ReduxStateType, R>;

export const useSelector: TypedUseSelectorHook<ReduxStateType> = useReduxSelector;

export const useDispatch: () => AppDispatch = useReduxDispatch;
